import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";
import StickyDemoBar from "@/components/StickyDemoBar";
import { initAnalytics, trackPageView } from "@/lib/analytics";

import Landing from "@/pages/Landing";
import RequestQuote from "@/pages/RequestQuote";
import Manufacturers from "@/pages/Manufacturers";
import Dealers from "@/pages/Dealers";
import Category from "@/pages/Category";
import About from "@/pages/About";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import ManufacturerDashboard from "@/pages/ManufacturerDashboard";
import AdminLeads from "@/pages/AdminLeads";
import AdminManufacturers from "@/pages/AdminManufacturers";
import AdminDemoRequests from "@/pages/AdminDemoRequests";
import AdminScorecard from "@/pages/AdminScorecard";
import Scorecard from "@/pages/Scorecard";
import Insights from "@/pages/Insights";
import InsightDetail from "@/pages/InsightDetail";
import AdminInsights from "@/pages/AdminInsights";
import Contact from "@/pages/Contact";
import HowItWorks from "@/pages/HowItWorks";
import Resources from "@/pages/Resources";
import SolutionsHub from "@/pages/solutions/Hub";
import SolutionsDealers from "@/pages/solutions/Dealers";
import SolutionsDistributors from "@/pages/solutions/Distributors";
import SolutionsSalesReps from "@/pages/solutions/SalesReps";
import NotFound from "@/pages/NotFound";

function AnalyticsTracker() {
  const location = useLocation();
  useEffect(() => { initAnalytics(); }, []);
  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AnalyticsTracker />
          <Navbar />
          <main className="min-h-[60vh]">
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/solutions" element={<SolutionsHub />} />
              <Route path="/solutions/manufacturers" element={<Manufacturers />} />
              <Route path="/solutions/dealers" element={<SolutionsDealers />} />
              <Route path="/solutions/distributors" element={<SolutionsDistributors />} />
              <Route path="/solutions/sales-reps" element={<SolutionsSalesReps />} />
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/resources" element={<Resources />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/scorecard" element={<Scorecard />} />
              <Route path="/request-quote" element={<RequestQuote />} />
              <Route path="/dealers" element={<Dealers />} />
              <Route path="/category/:slug" element={<Category />} />
              <Route path="/manufacturers" element={<Manufacturers />} />
              <Route path="/about" element={<About />} />
              <Route path="/insights" element={<Insights />} />
              <Route path="/insights/:slug" element={<InsightDetail />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute role="manufacturer">
                    <ManufacturerDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/leads"
                element={
                  <ProtectedRoute role="admin">
                    <AdminLeads />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/manufacturers"
                element={
                  <ProtectedRoute role="admin">
                    <AdminManufacturers />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/demo-requests"
                element={
                  <ProtectedRoute role="admin">
                    <AdminDemoRequests />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/scorecard"
                element={
                  <ProtectedRoute role="admin">
                    <AdminScorecard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/insights"
                element={
                  <ProtectedRoute role="admin">
                    <AdminInsights />
                  </ProtectedRoute>
                }
              />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
          <StickyDemoBar />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
